function SelezionaComprensorio({ comprensori, onSelect, showSelectButton = true }) {
  return (
    <div className="row">
      {comprensori.map((c) => (
        <div className="col-md-4 mb-3" key={c.id}>
          <div className="card h-100">
            <h5 className="card-header bg-info-subtle">{c.nome}</h5>
            <div className="card-body d-flex flex-column">
              <p className="card-text">
                {c.comuni && c.comuni.length > 0
                  ? c.comuni.join(", ")
                  : "Nessun comune registrato"}
              </p>

              {showSelectButton && (
                <div className="mt-auto">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => onSelect && onSelect(c)}
                  >
                    Seleziona
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SelezionaComprensorio;
